import log from "loglevel";
import * as React from "react";
import { useState, useEffect } from "react";
import { AiFillPushpin } from "react-icons/ai";
// import { AiOutlinePushpin } from "react-icons/ai";
// import { FaEdit } from 'react-icons/fa';
// import { MdDelete } from 'react-icons/md';
// import * as constants from "Constants";
import httpService from 'services/httpService.js';
import { store } from "Store";
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import AccordionContext from "react-bootstrap/AccordionContext";
import { Container, Row, Col, Accordion, Card, Spinner } from "react-bootstrap";
import { useContext } from "react";
import ReactHtmlParser from 'react-html-parser';
import { useParams } from "react-router-dom";
import moment from "moment";


function ContextAwareToggle({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey)
    );

    const isCurrentEventKey = currentEventKey === eventKey;

    if (isCurrentEventKey) {
        return (
            <Row>
                <Col xs={10} sm={11}>{children}</Col>
                <Col xs={2} sm={1}>
                    <RiArrowDropDownLine
                        size={35}
                        color="grey"
                        style={{ margin: "-10 0 -10 10" }}
                    />
                </Col>
            </Row>
        );
    } else {
        return (
            <Row>
                <Col xs={10} sm={11}>{children}</Col>
                <Col xs={2} sm={1}>
                    <RiArrowDropRightLine
                        size={35}
                        color="grey"
                        style={{ margin: "-10 0 -10 10" }}
                    />
                </Col>
            </Row>
        );
    }
}

const CourseAnnouncementsStudent = (props) => {

    const params = useParams();
    const { courseId } = params;
    // const [announcements, setAnnouncemen] = useState([]);
    // const [announcementInput, setAnnouncementInput] = useState("");
    // const [searchInputText, setSearchInputText] = useState("");
    // const [startDate, setStartDate] = useState("");
    // const [endDate, setEndDate] = useState("");
    // const [editing, setEditing] = useState("");
    // const [announcement_notification, setAnnouncement_notification] = useState(false);
    // const [announcement_checkbox, setAnnouncement_checkbox] = useState(false);

    const [currState, setCurrState] = useState({
        announcements: [],
        announcementInput: "",
        editing: new Set(),
        announcement_notification: false,
        announcement_checkbox: false,
    });

    const [search, setSearch] = useState({
        searchInputText: "",
        startDate: "",
        endDate: "",
    });

    const [announcements, setAnnouncements] = useState(null);
    const [announcementsToShow, setAnnouncementsToShow] = useState(null);

    const getUser = () => {
        const state = store.getState();
        return state.userInfo;
    };

    const announcementnotification = async () => {
        let url = '/courseware/api/courseinfo/' + courseId + '/?format=json';
        try {
            const res = await httpService.get(url);
            const data = res.data;
    
            setCurrState({
                ...currState,
                announcement_notification: res.announcement_notification
            });
            log.log(res, " Announcement Notification");
        } catch (error) {
            log.log(error);
        }
    };

    const fetchAnnouncements = async () => {
        let url = "/announcements/api/announcement/" + courseId + "/get_all_announcements/?format=json";
        try {
            const res = await httpService.get(url);
            const data = res.data;
            log.log({ announcements: data });
            if (data.isEmpty) {
                setAnnouncements([]);
            } else {
                data.all = data.all.map((announcement) => {
                    announcement.editedText = announcement.description;
                    return announcement;
                });
                setAnnouncements(data.all);
            }
        } catch (error) {
            log.log(error);
        }
    };

    useEffect(() => {
        fetchAnnouncements();
        announcementnotification();
    }, []);

    useEffect(() => {
        if (Array.isArray(announcements) && announcements.length > 0) {
            let anS = announcements.sort((a, b) => (a.pinned ? -1 : 1)).filter((announcement) =>
                announcement.description.toLowerCase().includes(search.searchInputText.toLowerCase().trim())
                && (!search.startDate || new Date(announcement.publish_date) >= new Date(search.startDate))
                && (!search.endDate || new Date(announcement.publish_date) <= new Date(search.endDate))
            );
            setAnnouncementsToShow(anS);
        } else {
            if (!announcements){
                setAnnouncementsToShow(null);
            } else {
                setAnnouncementsToShow([]);
            }
        }
    }, [announcements, search.searchInputText, search.endDate, search.startDate]);

    const handlePin = async (id) => {
        const user = getUser();
        let url = `/announcements/api/announcement/${id}/pinUnpin_announcement/?format=json`;
        try {
            await httpService.instance({
                method: "patch",
                url: url,
                headers: {
                    Authorization: `Token ${user.token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            fetchAnnouncements();
            alert("Announcement pinned");
        } catch (error) {
            log.log(error);
        }
    };

    return (
        <Container fluid className="p-1 p-md-3 px-1 px-md-4 mt-2">
            {/* <Row className="d-flex align-items-center">
                    <Col md={{ span: 4, offset: 0 }}>
                        <h4 style={{ color: 'grey' }}>
                            Course Announcements
                        </h4>
                    </Col>
                </Row> */}

            {/* <hr
                    style={{
                        marginLeft: 5,
                        marginRight: 5,
                        height: '1px',
                        border: 'none',
                        backgroundColor: 'grey'
                    }}
                /> */}

            <div className="mb-4">
                <Accordion>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            <ContextAwareToggle eventKey="0">
                                Search
                            </ContextAwareToggle>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        placeholder="Enter search item..."
                                        value={search.searchInputText}
                                        onChange={(e) =>
                                            setSearch({
                                                ...search,
                                                searchInputText: e.target.value,
                                            })
                                        }
                                    ></input>
                                </div>
                                <div className="row" style={{ display: "flex", alignItems: "flex-end" }}>
                                    <div className="col-xs-12 col-md-4">
                                        <label htmlFor="sdate">Start Date</label>
                                        <input
                                            className="form-control"
                                            id="sdate"
                                            name="sdate"
                                            type="date"
                                            value={search.startDate}
                                            onChange={(e) => setSearch({ ...search, startDate: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-md-4">
                                        <label htmlFor="edate">End Date</label>
                                        <input
                                            className="form-control"
                                            id="edate"
                                            name="edate"
                                            type="date"
                                            value={search.endDate}
                                            onChange={(e) => setSearch({ ...search, endDate: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-md-4">
                                        <button className="btn btn-warning mt-3 mt-md-0" onClick={() => {
                                            log.log(search);
                                            setSearch({ endDate: "", startDate: "", searchInputText: "" });
                                        }}>
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
            <div className="mb-4">
                {
                    Array.isArray(announcementsToShow) && announcementsToShow.length > 0 ?
                        <>{
                            announcementsToShow.map((announcement) =>
                                <div
                                    className="card card-body mb-2 announcement-content"
                                    style={{ position: "relative" }}
                                >
                                    <b data-reactid=".1.1.0.0.3.0.1.0.0" style={{ display: 'inline-block' }}>
                                        {moment(announcement.publish_date).format("MMM DD, YYYY HH:MM A")}:{" "}
                                    </b>
                                    {announcement.pinned &&
                                        <div
                                            className="d-flex"
                                            style={{
                                                position: "absolute",
                                                top: 5,
                                                right: 10,
                                            }}
                                            title={"pinned by instructor"}
                                        >

                                            <button
                                                className="btn btn-sm"
                                                onClick={() => { }
                                                }
                                            >

                                                <AiFillPushpin size={18} />
                                            </button>

                                        </div>
                                    }

                                    {ReactHtmlParser(announcement.description)}

                                </div>
                            )}
                        </> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60svh" }}>
                            {
                                Array.isArray(announcementsToShow) && announcementsToShow.length === 0
                                    ? <h5 className="text-center text-muted">No Announcements</h5>
                                    : <Spinner animation="border" />
                            }
                        </div>
                }
            </div>
        </Container>
    )
}

export default CourseAnnouncementsStudent;